import { useQuery } from 'react-query';
import { useClientId } from '../../_hooks/useClientId';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { queryKeys } from './queryKeys';

interface FetchProposedPlansParams {
  clientId: string;
}

export interface ProposedPlanDTO {
  description: string | null;
  isCurrent: boolean;
  name: string;
  planId: string;
}

const fetchProposedPlans = ({ clientId }: FetchProposedPlansParams): Promise<ProposedPlanDTO[]> =>
  authFetch(urlWithParams('/Consumer/ProposedPlans', { clientId }));

export const useProposedPlansQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.proposedPlans(`${clientId}`),

    () => fetchProposedPlans({ clientId: `${clientId}` }),
  );
};
